enum Status {
  Success = 'success',
  Failure = 'failure',
  Default = 'default',
}

export default Status;
